import { useDevice } from "../../../common/hooks/useDevice";
import { useEffect, useState } from "react";
import { defaultButtonSectionValue } from "../../../common/components/card/CustomGraphCard";
import { CustomDropdownBoxButton } from "../../../common/components/button/CustomDropdownBoxButton";
import CustomPeriodButton from "../../../common/components/button/CustomPeriodButton";
import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C2Text, T1Text } from "../../../common/components/text/CustomText";
import TicketChart from "../../../common/components/chart/TicketChart";
import { Theme } from "../../../common/Theme";
import TicketService from "../../../service/TicketService";

function TicketChartDashboardCard() {
    const currentDevice = useDevice();
    const service = new TicketService();

    const [dateRange, setDateRange] = useState(defaultButtonSectionValue[0].value);
    const [totalTickets, setTotalTickets] = useState(0);

    const fetchTicketStatus = () => {
        service
            .getTicketStatus()
            .then((result) => {
                setTotalTickets(result.totalTicket ?? 0);
            })
            .catch((error) => {
                console.error("Error fetching ticket status:", error);
            });
    };

    useEffect(() => {
        fetchTicketStatus();
    }, []);
    let buttonSection;
    if (currentDevice === "mobile") {
        buttonSection = (
            <CustomDropdownBoxButton
                icon={"date"}
                currentValue={dateRange}
                setValue={setDateRange}
                values={defaultButtonSectionValue}
            />
        );
    } else {
        buttonSection = (
            <CustomPeriodButton currentValue={dateRange} setValue={setDateRange} values={defaultButtonSectionValue} />
        );
    }

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"426px"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={"transparent"}
        >
            <Row width={"100%"} justifyContent={"space-between"} alignItem={"flex-start"}>
                <Column alignItem={"flex-start"}>
                    <C1Text>Ticket Trend</C1Text>
                    <SizedBox height={"5px"} />
                    <Row width={"100%"} justifyContent={"flex-end"}>
                        <T1Text>{totalTickets}</T1Text>
                        <SizedBox width={"5px"} />
                        <C2Text>Total Tickets</C2Text>
                    </Row>
                </Column>
                {buttonSection}
            </Row>

            <SizedBox height={"15px"} />
            <TicketChart />
        </SizedBox>
    );
}

export default TicketChartDashboardCard;
